// RootRedirect.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "AuthContext";
import { CircularProgress } from "@mui/material";

const RootRedirect = () => {
  const { isAuthenticated, loading } = useAuth();
    console.log(isAuthenticated , "isAuthenticatedisAuthenticated")
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100vw",
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: 9999,
        }}
      >
        <CircularProgress size={60} color="primary" />
      </div>
    );
  }

  return (
    <Navigate
      to={isAuthenticated ? "/admin/dashboard" : "/auth/login-page"}
      replace
    />
  );
};

export default RootRedirect;
